import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CropOriginalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"crop_original"}/>
}
